import React from 'react'

interface Properties {
    title: string
    index: string
}

export default function SectionTitle({title, index}: Properties) {
    const tag = `YC//${title.slice(0, 3).toUpperCase()}.${index}`
    return (
        <div className="print-avoid-break">
            <p className="font-display font-bold text-[11px] uppercase tracking-[.3em] text-accent">
                {'// SYS.'}{index}
            </p>
            <div className="mt-1 flex items-end justify-between pb-2">
                <h2 className="font-display font-bold uppercase tracking-[.04em] text-2xl md:text-3xl leading-none text-ink">
                    {title}
                </h2>
                <span className="hidden sm:block font-mono text-[9.5px] tracking-[.2em] text-faint">
                    {tag}
                </span>
            </div>
            <div className="h-[2px] bg-gradient-to-r from-primary via-accent to-transparent" />
        </div>
    )
}
